import { reduce, merge, keys, pipe } from 'ramda';
import { css } from 'styled-components';

export const breakpointSizes = Object.freeze({
  desktop: 1280,
  tablet: 700,
});

// @ts-ignore
const mediaQuery = (breakpoint: number) => (strings: TemplateStringsArray, ...interpolations: Interpolation<Theme>[]) => css`
  @media (min-width: ${breakpointSizes[breakpoint]}px) {
    ${css(strings, ...interpolations)}
  }
`;

const breakpointReducer = (acc, breakpoint) => merge(acc, { [breakpoint]: mediaQuery(breakpoint) });

export const buildBreakpoints = pipe(keys, reduce(breakpointReducer, {}));

export default buildBreakpoints(breakpointSizes);
